export default __webpack_public_path__ + "static/HansProfilePic-511b54503fe0310f242c0c8a88f4bf4d.jpg";